var KeywordBar, base, placeholderState, unparam, whichKeyAlias;

unparam = require('../../general/m_unparam');

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

placeholderState = require('../helper/m_common').placeholderState;

module.exports = KeywordBar = (function() {
  function KeywordBar(arg) {
    var el, env, initialKeyword;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.$input = this.$el.find('#search, #ls-search');
    this.placeholder = this.$input.attr('placeholder');
    this.bind();
    if (!_.isBlank(initialKeyword = unparam().query)) {
      placeholderState.set(this.$input, 'hide');
      this.val(initialKeyword);
    }
    return;
  }

  KeywordBar.prototype.bind = function() {
    return this.$input.on('keydown', (function(_this) {
      return function(e) {
        if (whichKeyAlias(e) === 'Enter') {
          _this.$el.trigger('submit');
        }
      };
    })(this));
  };

  KeywordBar.prototype.setKeyword = KeywordBar.val;

  KeywordBar.prototype.val = function(value) {
    var currentVal;
    if (value != null) {
      return this.$input.val(value).removeClass('prompting');
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal) || currentVal === this.placeholder) {
        return null;
      }
      return currentVal.trim();
    }
  };

  return KeywordBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  KeywordBar: KeywordBar
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL3ZpZXcvbV9rZXl3b3JkX2Jhci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvc2tpbS9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvdmlldy9tX2tleXdvcmRfYmFyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE9BQUEsR0FBdUIsT0FBQSxDQUFRLHlCQUFSOztBQUNyQixnQkFBcUIsT0FBQSxDQUFRLHNCQUFSOztBQUNyQixtQkFBcUIsT0FBQSxDQUFRLG9CQUFSOztBQUV2QixNQUFNLENBQUMsT0FBUCxHQUF1QjtFQUNSLG9CQUFDLEdBQUQ7QUFDWCxRQUFBO0lBRGEsYUFBSTtJQUNqQixJQUFDLENBQUEsR0FBRCxHQUFPO0lBQ1AsSUFBQyxDQUFBLEdBQUQsR0FBTyxHQUFBLElBQU87SUFDZCxJQUFDLENBQUEsTUFBRCxHQUFVLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLHFCQUFWO0lBQ1YsSUFBQyxDQUFBLFdBQUQsR0FBZSxJQUFDLENBQUEsTUFBTSxDQUFDLElBQVIsQ0FBYSxhQUFiO0lBRWYsSUFBQyxDQUFBLElBQUQsQ0FBQTtJQUVBLElBQUEsQ0FBTyxDQUFDLENBQUMsT0FBRixDQUFVLGNBQUEsR0FBaUIsT0FBQSxDQUFBLENBQVMsQ0FBQyxLQUFyQyxDQUFQO01BQ0UsZ0JBQWdCLENBQUMsR0FBakIsQ0FBcUIsSUFBQyxDQUFBLE1BQXRCLEVBQThCLE1BQTlCO01BQ0EsSUFBQyxDQUFBLEdBQUQsQ0FBSyxjQUFMLEVBRkY7O0FBR0E7RUFYVzs7dUJBYWIsSUFBQSxHQUFNLFNBQUE7V0FDSixJQUFDLENBQUEsTUFBTSxDQUFDLEVBQVIsQ0FBVyxTQUFYLEVBQXNCLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxDQUFEO1FBQ3BCLElBQUcsYUFBQSxDQUFjLENBQWQsQ0FBQSxLQUFvQixPQUF2QjtVQUNFLEtBQUMsQ0FBQSxHQUFHLENBQUMsT0FBTCxDQUFhLFFBQWIsRUFERjs7TUFEb0I7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQXRCO0VBREk7O3VCQU1OLFVBQUEsR0FBWSxVQUFDLENBQUE7O3VCQUViLEdBQUEsR0FBSyxTQUFDLEtBQUQ7QUFDSCxRQUFBO0lBQUEsSUFBRyxhQUFIO2FBQ0UsSUFBQyxDQUFBLE1BQ0MsQ0FBQyxHQURILENBQ08sS0FEUCxDQUVFLENBQUMsV0FGSCxDQUVlLFdBRmYsRUFERjtLQUFBLE1BQUE7TUFLRSxVQUFBLEdBQWEsSUFBQyxDQUFBLE1BQU0sQ0FBQyxHQUFSLENBQUE7TUFFYixJQUFlLENBQUMsQ0FBQyxPQUFGLENBQVUsVUFBVixDQUFBLElBQXlCLFVBQUEsS0FBYyxJQUFDLENBQUEsV0FBdkQ7QUFBQSxlQUFPLEtBQVA7O2FBQ0EsVUFBVSxDQUFDLElBQVgsQ0FBQSxFQVJGOztFQURHOzs7Ozs7O01BYWUsQ0FBQyxZQUFhOzs7QUFDcEMsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFoQyxFQUEyQztFQUFDLFlBQUEsVUFBRDtDQUEzQyJ9
